import {useCallback, useEffect, useState} from "react";
import {callApi} from "../../actions/base";
import {HTTP_METHOD} from "../../constants/http";

const useFetch = (uri, params = null, method = HTTP_METHOD.GET) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resource, setResource] = useState(null);

  const onSuccess = ({data}) => {
    setResource(data);
    setLoading(false);
  };

  const onError = ({ error }) => {
    setLoading(false);
    setError(error);
  };

  const fetchResource = useCallback(() => {
    setLoading(true);
    callApi(uri, params, onSuccess, onError, method);
  }, [uri, method, params]);

  useEffect(() => {
    fetchResource();
  }, [fetchResource]);

  return {
    error,
    loading,
    resource,
  };
};

export default useFetch;
